<template>
  <div>
    <!-- :rules="sliderRules()" -->
    <div
      class="d-flex justify-space-between align-items-end"
      style="width: 100%; align-items: flex-end"
    >
      <div>Faster</div>
      <div class="d-flex justify-center">
        <v-chip
          class="mr-2"
          :color="monthlyObligationLessThan ? 'primary' : 'warning'"
          label
          outlined
          v-if="modelValue"
        >
          SPA: &nbsp;&nbsp;<span :class="`font-weight-bold ${monthlyObligationLessThan?'primary--text':'secondary--text'}`">
            {{ monthlyObligation | toINR }}
          </span>
        </v-chip>

        <!-- <v-chip
          class="mr-2"
          :color="tenureLessGreaterThanEqual ? 'red' : 'primary'"
          label
          outlined
          >Tenure: &nbsp;&nbsp;<span
            :class="`font-weight-bold ${
              tenureLessGreaterThanEqual ? 'danger--text' : 'secondary--text'
            }`"
            >{{ modelValue }} mths</span
          >
        </v-chip> -->
        <v-chip
          class="mr-2"
          :color="tenureLessGreaterThanEqual ? 'red' : 'primary'"
          label
          outlined
          >Remaining Tenure: &nbsp;&nbsp;<span
            :class="`font-weight-bold ${
              tenureLessGreaterThanEqual ? 'danger--text' : 'secondary--text'
            }`"
            >{{ remainingTenure }} mths</span
          >
        </v-chip>
        
      </div>
      <div>Slower</div>
    </div>

    <v-slider
    dense
    :hide-details="true"
      :disabled="disabled"
      v-bind="$props"
      :min="1"
      :max="90"
      :value="modelValue"
      @input="(newValue) => (modelValue = newValue)"
    >
    </v-slider>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { VSlider } from "vuetify/lib";

import * as Data from "@/../src-gen/data";
import * as Store from "@/../src-gen/store";

@Component({
  components: {
    VSlider,
  },
})
export default class FRangeSliderSPA extends Vue {
  // MODEL VALUE - START
  @Prop()
  value: any;
  @Prop({ default: 0 })
  outstanding: number;
  @Prop({ default: 0 })
  totalPercentage: number;
  @Prop({ default: false })
  disabled: boolean;

  @Prop()
  tenureApproval: number;
  @Prop()
  affordability: number;
  @Prop({default: 0})
  spaPaidCount: number;
  
  @Store.Getter.ClientFile.ClientFileSummary.fileSummary
  clientFileSummary: Data.ClientFile.FileSummary;

  get modelValue() {
    return this.value || 0;
  }
  set modelValue(newModelValue: any) {
    this.$emit("input", newModelValue);
  }

  get monthlyObligationGreaterThanEqual() {
    return Math.round(this.remainingTenure) >= Math.round(this.affordability);
  }

  get tenureLessGreaterThanEqual() {
    return this.remainingTenure > this.tenureApproval;
  }

  get repaymentAmountWithoutSPABalance() {
      return (this.outstanding * this.totalPercentage) / 100;
  }

  get repaymentAmount() {
    return (this.repaymentAmountWithoutSPABalance - (this.clientFileSummary?.spaBalance||0))
  }

  get monthlyObligation() {
    return Math.ceil(this.repaymentAmount / this.remainingTenure);
  }

  get remainingTenure() {
    return this.modelValue-this.spaPaidCount;
  }

    get monthlyObligationLessThan() {
    return (
      Math.round(this.remainingTenure) <=
      Math.round(this.affordability)
    );
  }

  // MODEL VALUE - END

  // sliderRules() {
  //     return [
  //       (v: number) => this.modelValue.tenure <= this.modelValue.tenureApproval,
  //       (v: number) =>
  //         Math.round(this.modelValue.monthlyObligation) <=
  //         Math.round(this.modelValue.affordability),
  //     ];
  //   }
}
</script>

